<template>
    <header>
        <div class="topbar d-flex align-items-center">
            <nav class="navbar navbar-expand w-100 topbar-nav">
                <div class="mobile-toggle-menu"><i class='bx bx-menu'></i></div>
                <div class="topbar-left">
                    <span class="topbar-page-label">Admin Panel</span>
                </div>
                <div class="ms-auto user-box dropdown">
                    <a class="d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret user-chip"
                       href="#"
                       role="button"
                       data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <div class="user-avatar">
                            <span>{{ userInitial }}</span>
                        </div>
                        <div class="user-info d-none d-md-block">
                            <p class="user-name mb-0">{{ auth.name }}</p>
                            <p class="user-email mb-0">{{ auth.email }}</p>
                        </div>
                        <i class="bx bx-chevron-down user-caret d-none d-md-inline"></i>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end user-menu">
                        <li class="user-menu-header px-3 py-2 d-md-none">
                            <div class="fw-medium">{{ auth.name }}</div>
                            <small class="text-muted">{{ auth.email }}</small>
                        </li>
                        <li><hr class="dropdown-divider my-1 d-md-none"></li>
                        <li @click="logout">
                            <a class="dropdown-item" href="javascript:void(0);">
                                <i class='bx bx-log-out-circle'></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </header>
</template>

<script>
import store from "../../Store/store";

export default {
    computed: {
        auth: function () {
            return store.getters.GetAuth || {}
        },
        userInitial: function () {
            const name = this.auth.name || 'A'
            return name.charAt(0).toUpperCase()
        }
    },
    methods: {
        logout: function () {
            this.$store.dispatch('Logout')
        }
    }
}
</script>

<style scoped>
.topbar-nav {
    gap: 0.75rem;
}

.topbar-left {
    display: flex;
    align-items: center;
}

.topbar-page-label {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
    letter-spacing: 0.2px;
}

.user-chip {
    padding: 0.3rem 0.55rem 0.3rem 0.3rem;
    border-radius: 999px;
    border: 1px solid #e5e7eb;
    background: #fff;
    gap: 0.5rem;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.user-chip:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

.user-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: rgba(37, 99, 235, 0.12);
    color: #2563eb;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    flex-shrink: 0;
}

.user-info {
    text-align: left;
    line-height: 1.2;
    padding-right: 0.15rem;
}

.user-name {
    font-family: Roboto, sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #334155;
}

.user-email {
    font-family: Roboto, sans-serif;
    font-size: 11px;
    font-weight: 400;
    color: #94a3b8;
}

.user-caret {
    font-size: 16px;
    color: #94a3b8;
}

.user-menu {
    min-width: 180px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 0.35rem;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    font-size: 13px;
    font-weight: 500;
    color: #475569;
    border-radius: 8px;
    padding: 0.55rem 0.75rem;
}

.dropdown-item:hover {
    background: #f1f5f9;
    color: #2563eb;
}

.dropdown-item i {
    font-size: 16px;
}
</style>
